import React, { useEffect, useState } from 'react';
import { AuthContext, MyContext } from '../context/AuthContext';
import { FollowsContext } from '../context/FollowsContext';
import { Followable, FollowData } from '../model/types';
import { Button, Box, Tooltip } from '@mui/material';
import SubmitPostComponent from '../SubmitPostComponent/SubmitPostComponent';
import { DateTime } from 'luxon';
import { Link } from 'react-router-dom';
import FollowIcon from '../resource/FollowIcon';
import CheckIcon from '@mui/icons-material/Check';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
function FollowButton({
  parentRecord,
  objectType,
  isPermanent = false,
}: {
  parentRecord: Followable;
  objectType: string;
  isPermanent?: boolean;
}) {
  const userRecord = React.useContext<MyContext>(AuthContext).userRecord;
  const { follows } = React.useContext(FollowsContext);
  const [expand, setExpand] = useState(false);
  const [followState, setFollowState] = useState('notFollowing');
  const [follow, setFollow] = useState<FollowData | undefined>(undefined);

  const toggleAcordion = () => {
    setExpand((prev) => !prev);
  };

  function followIsExpired(follow: FollowData) {
    if (
      follow.is_expired ||
      DateTime.fromISO(follow.expire_at).toJSDate() < new Date()
    )
      return true;

    return false;
  }
  function handleSubmit() {
    toggleAcordion();
  }

  useEffect(() => {
    if (!userRecord) return;
    follows.forEach((follow) => {
      if (follow.parent_id === parentRecord.id) {
        setFollow(follow);
        if (followIsExpired(follow)) {
          setFollowState('expired');
        } else setFollowState('following');
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRecord, parentRecord]);

  if (!userRecord) {
    return (
      <Link to="/login">
        <Button size="small" variant="outlined">Login to follow</Button>
      </Link>
    );
  }
  return (
    <Box>
      {followState === 'notFollowing' && (
        <Button onClick={() => toggleAcordion()}>
          {objectType === 'users' ? (
            <FollowIcon style={{ width: 30, height: 25 }} />
          ) : (
            'Follow ' + objectType.slice(0, -1)
          )}
        </Button>
      )}
      {followState === 'following' && (
        <Tooltip title="View your follow">
          <Button
            variant="outlined"
            size="small"
            component={Link}
            to={`/follows/${follow?.id}`}
            color="success"
            startIcon={<CheckIcon fontSize="small" />}
          >
            Following
          </Button>
        </Tooltip>
      )}

      {followState === 'expired' && (
        <Tooltip title="Your follow expired — view it or re-follow">
          <Button
            variant="outlined"
            size="small"
            component={Link}
            to={`/follows/${follow?.id}`}
            color="warning"
            startIcon={<WarningAmberIcon fontSize="small" />}
          >
            Expired
          </Button>
        </Tooltip>
      )}
      {expand && (
        <Box sx={{ mt: 1 }}>
          <Box sx={{ color: 'text.secondary', fontSize: '0.85rem', mb: 1 }}>
            Why are you following this {objectType.slice(0, -1)}?
          </Box>
          <SubmitPostComponent
            objectType="follows"
            parentID={parentRecord.id}
            parentType={objectType}
            onSubmit={handleSubmit}
          />
        </Box>
      )}
    </Box>
  );
}

export default FollowButton;
